import { RewardBanner, Text } from '@intigral/shared';
import React, { useMemo } from 'react';
import useLanguage from '../../../hooks/useLanguage';
import useBannerActions from '../hooks/useBannerActions';
import { BannerProps } from '../types/iBanner';
import { BannerBadge } from './elements';

const Banner: React.FC<BannerProps> = ({ carousel = {} }) => {
    // Hooks
    const language = useLanguage();
    const { title_p1, title_p2, ctaProps, onCtaClick, description, image, badgeUrl } = useBannerActions(carousel);

    // Memoized Heading
    const heading = useMemo(
        () => (
            <Text as="h3" variant="h3" margin="0" alignment="start" size="28" fontWeight="medium">
                {title_p1} <span className="orange">{title_p2}</span>
            </Text>
        ),
        [title_p1, title_p2, language]
    );

    return (
        <div className="container full-width" style={{ position: 'relative', overflow: 'hidden' }}>
            <RewardBanner
                image={image}
                heading={heading}
                description={description}
                cta={ctaProps}
                onCtaClick={onCtaClick}
                badge={<BannerBadge url={badgeUrl} />}
            />
        </div>
    );
};

export default Banner;
